import { Shirt, Footprints, Smartphone, Book, Gamepad2, Home, Dumbbell, Gift } from "lucide-react";

export const CATEGORY_ICONS = {
  "Vêtements": Shirt,
  "Chaussures": Footprints,
  "Électronique": Smartphone,
  "Livres": Book,
  "Jouets": Gamepad2,
  "Décoration": Home,
  "Sport": Dumbbell,
  "Autre": Gift
};

export const getCategoryIcon = (category) => {
  return CATEGORY_ICONS[category] || Gift;
};